import { render, staticRenderFns } from "./RulesCard.vue?vue&type=template&id=81b9e464"
import script from "./RulesCard.vue?vue&type=script&lang=ts"
export * from "./RulesCard.vue?vue&type=script&lang=ts"
import style0 from "./RulesCard.vue?vue&type=style&index=0&id=81b9e464&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports